import _objectDestructuringEmpty from '@babel/runtime/helpers/esm/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { CloseIcon, InformationIcon, CheckmarkBackgroundIcon, WarningIcon, CriticalIcon } from '@paypalcorp/pp-react-icons';
import { cx } from '@paypalcorp/pp-react-utils';
import * as styles from './styles.css';
export { styles as alertStyles };

var _excluded = ["className", "type", "typeIconAriaLabel", "closeButton", "closeButtonLabel", "children"];
// added this to match types on icon button
var alertTypes = ['info', 'success', 'error', 'warning'];
var icons = {
  info: InformationIcon,
  success: CheckmarkBackgroundIcon,
  warning: WarningIcon,
  error: CriticalIcon
};
var Alert = function (_ref) {
  var className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    _ref$typeIconAriaLabe = _ref.typeIconAriaLabel,
    typeIconAriaLabel = _ref$typeIconAriaLabe === void 0 ? type : _ref$typeIconAriaLabe,
    closeButton = _ref.closeButton,
    _ref$closeButtonLabel = _ref.closeButtonLabel,
    closeButtonLabel = _ref$closeButtonLabel === void 0 ? 'close alert' : _ref$closeButtonLabel,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var selectedType = alertTypes.includes(type) ? type : 'info';
  var AlertStatusIcon = icons[selectedType];
  var alertClasses = cx(styles.base, styles.alertColorStyles[selectedType], !closeButton && styles.noCloseBtn, className);
  var closeBtnEl;
  if (closeButton) {
    var otherProps = _extends({}, (_objectDestructuringEmpty(closeButton), closeButton));
    closeBtnEl = closeButton && /*#__PURE__*/React.createElement("span", {
      "data-ppui": "true"
    }, /*#__PURE__*/React.createElement(IconButton, _extends({
      className: styles.closeBtn,
      size: "sm",
      svgIconComponent: CloseIcon
    }, otherProps, {
      "data-ppui": "true"
    }), closeButtonLabel));
  }
  var alertSvgClasses = cx(styles.svgIcon, styles.alertIconStyles[selectedType]);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "alert",
    className: alertClasses,
    "data-ppui-info": "alert_4.1.3__8.12.0"
  }, rest), /*#__PURE__*/React.createElement(AlertStatusIcon, {
    size: "sm",
    className: alertSvgClasses,
    role: "img",
    "aria-label": typeIconAriaLabel,
    "data-ppui": "true"
  }), children, closeBtnEl);
};

export { Alert };
